import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/buildingLevel1/importer/buildingLevel1ImporterActions';

export default importerReducers(actions);
